import { useMutation } from '@tanstack/react-query';
import type { ResetPasswordInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';

interface ResetPasswordApiResponse {
  success: boolean;
  data: { message: string };
}

/**
 * Mutation hook for resetting password.
 * Calls POST /auth/reset-password.
 */
export function useResetPassword() {
  return useMutation<void, Error, ResetPasswordInput>({
    mutationFn: async (input) => {
      await apiClient.post<ResetPasswordApiResponse>('/auth/reset-password', input);
    },
  });
}
